// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e984f16f","239":"2e456366","667":"551e4d9e"}[chunkId] + ".chunk.js";
};